export default "__VITE_ASSET__C91WE4QV__"